export class Configuration {

  // ---------------------------------------------------------------------------------------
  // URLS FOR PRODUCTION SERVER / PRODUCTION END POINTS
  // ---------------------------------------------------------------------------------------
  public static portalUrl:string = "https://protoexpress.com/";
  public static oneFlowUrl:string = "https://oneflowapibackendproduction.app.protoexpress.com/api";
  public static scaBomUrl:string = "https://scaprod.app.protoexpress.com";
  public static REST_API_SERVER:string = "https://prodkicadbackend.app.protoexpress.com/";
  public static Guest_Email_Url:string = this.oneFlowUrl + "/oneflow/guestEmailInfo";
  public static Pcb_Quote_Url:string = this.oneFlowUrl + "/oneflow/";
  public static MAIN_URL:string = "https://customerbcvprodbackend.app.protoexpress.com";
  public static backendStagingServer:string = this.oneFlowUrl + "/oneflow";
  public static sierraStandardProductLink:string = "https://www.protoexpress.com/products/sierra-standard-product/";
  public static AppLocationBaseURL:string = this.scaBomUrl + "/bom";
  public static ADDRESS_REQUEST_URL:string = this.oneFlowUrl + "/oneflow";
  public static Order_Url : string = this.oneFlowUrl + "/oneflow";
  public static autoBOMFileDownloadUrl:string = "https://prodkicadbackend.app.protoexpress.com/superAPI?service=getFile&fileName=";
  public static scaBOMFileDownloadUrl:string = this.oneFlowUrl + "/oneflow/download-bom?bomId="; 
  public static Pcb_Specification_URL:string = this.portalUrl + "products/online-pcb-manufacturing/";
  public static Via_In_Pad_URL:string = this.portalUrl + "customer-portal/via-in-pad-features.jsp";
  public static Terms_And_Conditions_URL:string = this.portalUrl + "terms-and-conditions/";
  public static Customer_Care_URL:string = this.portalUrl + "customer-portal/customer-services/";
  public static FAQ_URL:string = this.portalUrl + "faq/web-order-pcbs/"
  public static QA_ORDER_URL:string = this.oneFlowUrl + "/oneflow/";
  public static stagOneflowUrl:string = 'https://oneflow.app.protoexpress.com';
  public static resaleCertiUrl:string = 'https://www.protoexpress.com/customer-portal/docs/CA-resale-certificate.pdf';
  public static stagingPortalUrl :string = 'https://protoexpress.com';
  public static customerPortalUrl:string = 'https://www.protoexpress.com/customer-portal/chkAuth/session-status-fems.jsp';
}
